import { render, staticRenderFns } from "./Pipp.vue?vue&type=template&id=4dcf836d&scoped=true"
import script from "./Pipp.vue?vue&type=script&lang=js"
export * from "./Pipp.vue?vue&type=script&lang=js"
import style0 from "./Pipp.vue?vue&type=style&index=0&id=4dcf836d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf836d",
  null
  
)

export default component.exports